import { useNavigate } from 'react-router-dom';
import '../styles/validacaoConvidados.css'

export default function ConfirmaValidacao() {
  const navigate = useNavigate();

    const confirmadoValidacao = () => {
        navigate('/');
    };

    setTimeout(() => {
        navigate('/');
    }, 5000);

    return <div className="valida_documento">
        
        <img src='/images/confirma_validacao.jpg' alt='validação do documento' className="img_validacao" onClick={confirmadoValidacao} />    
    
    </div>
}